import { throttle, throwTranslatableError } from '@/core';
import {
	getFilteredGlobalAddressesRequest,
	getAllGlobalAddressesRequest,
	newGlobalAddressRequest,
	getGlobalPostalPlaceRequest,
	updateGlobalAddressRequest,
	deleteGlobalAddressRequest,
} from '../requests';
import rdbClient from 'rdb-client';


async function fetchFilteredGlobalAddresses({}, filter) {
	let response = [];
	try {
		response = await getFilteredGlobalAddressesRequest(filter);
	} catch (err) {
		throw new Error('failedToFetch');
	}
	return response;
}

async function fetchAllGlobalAddresses({ state, commit }) {
	commit('setLoading', { key: 'fetchAllGlobalAddresses', isLoading: true });
	try {
		if (state.allGlobalAddresses.length === 0) {
			await fetchAllGlobalAddressesCore();
		} else {
			await throttle(fetchAllGlobalAddressesCore, 'fetchAllGlobalAddresses', 60 * 1000);
		}
	} catch (err) {
		commit('setLoading', { key: 'fetchAllGlobalAddresses', isLoading: false });
		throw new Error('failedToFetch');
	}
	commit('setLoading', { key: 'fetchAllGlobalAddresses', isLoading: false });

	async function fetchAllGlobalAddressesCore() {
		let response = await getAllGlobalAddressesRequest();
		commit('setAllGlobalAddresses', response);
	}
}

async function addNewGlobalAddress({ commit }, { originalAddress, newAddress } ) {
	let response = newAddress;
	try {
		// Replace issues in create patch due to client side reactivity formatting of address
		// Remove any undefined from the original to force them
		let cleanOriginal = {};
		let keys = Object.keys(originalAddress).filter(x => originalAddress[x] !== undefined);
		for (let key of keys) {
			cleanOriginal[key] = originalAddress[key];
		}
		let patch = rdbClient.createPatch(cleanOriginal, newAddress);

		response = await newGlobalAddressRequest({ patch, newAddress });
		commit('clearErrors');
	} catch (e) {
		if (e.response && e.response.data && e.response.data.errors) {
			commit('setErrors', e.response.data.errors);
		}
		throwTranslatableError(e, 'failedToSave');
	}
	return response;
}

async function getGlobalPostalPlace({}, { postalCode, countryCode }) {
	let response = {};
	try {
		response = await getGlobalPostalPlaceRequest({ postalCode, countryCode });
	} catch (err) {
		throw new Error('failedToFetch');
	}
	return response;
}

async function addEmptyGlobalAddress({ state, commit } ) {

	let address = {
		id: null,
		name: '',
		street: '',
		postalCode: '',
		postalPlace: '',
		countryCode: 'NO',
		latitude: null,
		longitude: null
	};
	try {
		let response = await newGlobalAddressRequest({ newAddress: address });

		address.id = response.id;
		//commit('clearErrors');
		let { allGlobalAddresses } = state;
		allGlobalAddresses.unshift(address);

		commit('set', () => { state.allGlobalAddresses = allGlobalAddresses; });
	} catch (e) {
		if (e.response && e.response.data && e.response.data.errors) {
			//commit('setErrors', e.response.data.errors);
		}
		throwTranslatableError(e, 'failedToAdd');
	}
	return address;
}

async function updateGlobalAddress({ commit }, { globalAddress, key, value }) {
	if (globalAddress[key] === value) return;

	let globalAddressClone = JSON.parse(JSON.stringify(globalAddress));
	commit('set', () => { globalAddress[key] = value; });

	let patch = rdbClient.createPatch(globalAddressClone, globalAddress);
	try {
		await updateGlobalAddressRequest(globalAddress.id, { patch });

	} catch (e) {
		throw throwTranslatableError(e, 'failedToUpdate');
	}
}

async function deleteGlobalAddresses({ state, commit }, globalAddressesToDelete) {
	let storedGlobalAddresses = state.allGlobalAddresses;
	let idsToRemove = globalAddressesToDelete
		.map(address => address.id);

	try {
		for (let id of idsToRemove) {
			await deleteGlobalAddressRequest(id);
		}
		let updatedGlobalAddresses = storedGlobalAddresses.filter(x => idsToRemove.indexOf(x.id) < 0);
		commit('set', () => { state.allGlobalAddresses = updatedGlobalAddresses; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

export default {
	fetchFilteredGlobalAddresses,
	fetchAllGlobalAddresses,
	addNewGlobalAddress,
	getGlobalPostalPlace,
	addEmptyGlobalAddress,
	updateGlobalAddress,
	deleteGlobalAddresses,
};
